<template>
  <div
    class="container"
    style="padding-top: 100px;"
  >
    Oh you are naughty! You are not a verified user, and could be absolutely anyone!
    Please check your email for a verification email. If you would like us to send you another one, place click here
    <button
      type="button"
      class="btn btn-primary"
      @click="resendVerificationEmail()"
    >
      here
    </button>

    If you have already verified your email please reload this page <router-link
      class="nav-btn"
      :to="{ name: 'Home' }"
    >
      Here
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'UserNotVerified',
  methods: {
    resendVerificationEmail: () => {
      const user = firebase.auth().currentUser
      console.log(user)
      user.sendEmailVerification().then(() => {
        // Email sent.
        console.log('Email sent')
        firebase.auth().signOut()
      }, function (error) {
        // An error happened.
        console.log('Email verification not sent. An error has occurred! >>' + error)
      })
    }
  }
}

</script>

<style>
</style>
